import styled from '@emotion/styled'

const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export { RootContainer }
